import { render, staticRenderFns } from "./DashboardCards.vue?vue&type=template&id=433ace0c&scoped=true&"
import script from "./DashboardCards.vue?vue&type=script&lang=js&"
export * from "./DashboardCards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCards.vue?vue&type=style&index=0&id=433ace0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ace0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VImg})
